<template>
  <modal
    class="warningModal"
    name="warningModal"
    transition="pop-out"
    :clickToClose="false"
  >
    <div class="suspended_modal row">
      <!-- <div class="col-md-3 suspended_emoji">
        <img src="@/assets/img/dissapointment.svg" />
      </div> -->
      <div class="col-md-9 epump_sub_content">
        <p class="epump_sub">
          <span class="dear_span">{{ $t("text.dModal.dearCustomer") }}</span>
          {{ $t("text.dModal.accessDisabled") }}
        </p>
        <div class="mt-4 epump_payment">
          <p class="epump_sub font-weight-bold">
            {{ $t("text.cMasterLayout.contactCom") }}
          </p>
          <button
            class="payment_button float-right mt-3"
            @click="$router.go(-1)"
          >
            <!-- {{ $t("text.cMasterLayout.logOut") }} -->No
          </button>
          <button class="payment_button float-right mt-3" @click="closeModal">
            <!-- {{ $t("text.cMasterLayout.logOut") }} -->
            Yes
          </button>
        </div>

        <!-- <button class="payment_button">Make payment now</button> -->
        <router-link
          :to="{
            name: branch
              ? 'branch_invoice'
              : industry
              ? 'industrial_admin_invoice'
              : 'company_invoice',
            query:
              branch && this.$route.query.branchId
                ? { branchId: this.$route.query.branchId }
                : industry && this.$route.query.companyID
                ? { companyID: this.$route.query.companyID }
                : null,
          }"
          class="view_invoices_text"
          v-show="
            $route.name !== 'company_invoice' &&
            $route.name !== 'branch_invoice' &&
            $route.name !== 'industrial_admin_invoice'
          "
        >
          <div class="payment_button">
            {{ $t("text.dModal.viewInvoices") }}
          </div>
        </router-link>
        <button
          class="payment_button"
          v-show="
            $route.name == 'company_invoice' ||
            $route.name == 'branch_invoice' ||
            $route.name == 'industrial_admin_invoice'
          "
          @click="closeModal"
        >
          {{ $t("text.dModal.viewInvoices") }}
        </button>
      </div>
    </div>
  </modal>
</template>
<script>
import configObject from "@/config";
import JQuery from "jquery";
let $ = JQuery;

const MODAL_WIDTH = 980;
// const MODAL_WIDTH = 1340;

export default {
  name: "warningModal",
  props: {
    recordDays: {
      type: Number,
      required: true,
      default: 0,
    },
    lastFilledDate: {
      type: String,
      required: true,
      default: "",
    },
  },
  data() {
    return {
      modalWidth: MODAL_WIDTH,
      isButtonDisabled: false,
      modalDataValues: {},
      pumpName: "",
    };
  },
  created() {
    this.modalWidth =
      window.innerWidth < MODAL_WIDTH ? MODAL_WIDTH / 2 : MODAL_WIDTH;
  },
  methods: {
    closeModal() {
      this.$modal.hide("warningModal");
    },
  },
};
</script>
